import classes from "./SecurityAgreement.module.css";
import { Link } from "react-router-dom";
import BreadCrumbComp from "../components/BreadCrumbComp";
import PageSchema from "../components/PageSchema";

export default function SecurityAgreement() {
  return (
    <>
      <PageSchema
        type="WebPage"
        title="Security Agreement - How Prime Cloud Systems Protects Your Personal Data"
        description="At Prime Cloud Systems, your privacy matters. Learn how we securely collect, use, and protect customer information while shopping for IT hardware online."
        url="https://primecloudsystems.com/security-agreement"
        breadcrumbs={[
          { name: "Home", url: "https://primecloudsystems.com/" },
          {
            name: "Security Agreement",
            url: "https://primecloudsystems.com/security-agreement",
          },
        ]}
      />

      <BreadCrumbComp
        currentPage="Security Agreement"
        title="Security Agreement | Prime Cloud Systems"
        description="Review Prime Cloud Systems’ Security Agreement outlining data protection, system security, compliance standards, and customer responsibilities to ensure safe and reliable IT services."
      />

      <div className={`container ${classes.SecurityAgreementContainer}`}>
        <p className={classes.paragraph}>
          <b>
            Following are the rules concerning the right use of the{" "}
            <Link to={"https://primecloudsystems.com"}>
              <b>primecloudsystems</b>
            </Link>{" "}
          </b>
        </p>
        <p className={classes.paragraph}>
          When an order is successfully completed, delivered, and accepted by
          the customer, the customer allows{" "}
          <Link to={"https://primecloudsystems.com"}>
            <b>primecloudsystems</b>
          </Link>{" "}
          the right to continuing purchase money security interest,’ as security
          for any due or timely payments of all payable amounts under any
          purchased order from the customer. It grants hereby the rights in all
          products or any proceeds the customer has any right, title, or
          interest in.
        </p>
        <p className={classes.paragraph}>
          Customers shall join with{" "}
          <Link to={"https://primecloudsystems.com"}>
            <b>primecloudsystems</b>
          </Link>{" "}
          at its punctual request in order to complete financing statements, any
          adjustments, or continuation statements, and pay the filing cost of
          the same at any time{" "}
          <Link to={"https://primecloudsystems.com"}>
            <b>primecloudsystems</b>
          </Link>{" "}
          estimates necessary; customer shall complete and deliver to{" "}
          <Link to={"https://primecloudsystems.com"}>
            <b>primecloudsystems</b>
          </Link>{" "}
          all documents, devices, and do as{" "}
          <Link to={"https://www.primecloudsystems.com"}>
            <b>www.primecloudsystems.com</b>
          </Link>{" "}
          may request in order to fully effectuate this Security Interest.
        </p>{" "}
        <p className={classes.paragraph}>
          If in case the customer/buyer is in default under the provided
          security agreement{" "}
          <Link to={"https://www.primecloudsystems.com"}>
            <b>www.primecloudsystems.com</b>
          </Link>{" "}
          reserves the right to request for remedies applicable by the Law.
        </p>
      </div>
    </>
  );
}
